var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyorders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_208",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 16.1875V10.4792L4.16667 7.58335V13.2917L9.16667 16.1875ZM10.8333 16.1875L15.8333 13.2917V7.58335L10.8333 10.4792V16.1875ZM9.16667 18.1042L3.33333 14.75C3.06944 14.5972 2.86458 14.3959 2.71875 14.1459C2.57292 13.8959 2.5 13.6181 2.5 13.3125V6.68752C2.5 6.38196 2.57292 6.10419 2.71875 5.85419C2.86458 5.60419 3.06944 5.4028 3.33333 5.25002L9.16667 1.89585C9.43056 1.74308 9.70833 1.66669 10 1.66669C10.2917 1.66669 10.5694 1.74308 10.8333 1.89585L16.6667 5.25002C16.9306 5.4028 17.1354 5.60419 17.2813 5.85419C17.4271 6.10419 17.5 6.38196 17.5 6.68752V13.3125C17.5 13.6181 17.4271 13.8959 17.2813 14.1459C17.1354 14.3959 16.9306 14.5972 16.6667 14.75L10.8333 18.1042C10.5694 18.257 10.2917 18.3334 10 18.3334C9.70833 18.3334 9.43056 18.257 9.16667 18.1042ZM13.3333 7.10419L14.9375 6.18752L10 3.33335L8.375 4.27085L13.3333 7.10419ZM10 9.04169L11.625 8.10419L6.6875 5.25002L5.0625 6.18752L10 9.04169Z",
    fill: "#333333"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyorders);
export default __webpack_public_path__ + "static/media/myorders.8a2ce743470cdaec8b2ba8dcd89313b7.svg";
export { ForwardRef as ReactComponent };